import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import PortalLayout from '../components/portal/PortalLayout';

/**
 * Reusable portal sub-page shell. Children fill the main content area.
 */
export default function PortalSubPage({
  eyebrow,
  title,
  intro,
  icon: Icon,
  children,
  cta,
}) {
  return (
    <PortalLayout>
      <div className="max-w-4xl mx-auto px-5 py-12">
        <Link
          to="/portal"
          className="inline-flex items-center gap-2 text-zinc-500 hover:text-[#D4AF37] font-manrope text-sm transition-colors mb-6"
          data-testid="portal-back-link"
        >
          <ArrowLeft className="w-4 h-4" /> Back to portal
        </Link>

        <header className="mb-10">
          {Icon && (
            <div className="w-14 h-14 rounded-2xl bg-[#D4AF37]/15 border border-[#D4AF37]/30 flex items-center justify-center mb-5">
              <Icon className="w-6 h-6 text-[#D4AF37]" />
            </div>
          )}
          {eyebrow && (
            <p className="text-[#D4AF37] font-manrope uppercase tracking-[0.3em] text-xs font-bold mb-4">
              {eyebrow}
            </p>
          )}
          <h1 className="font-cormorant text-4xl md:text-6xl font-medium text-white leading-[1.05] mb-4">
            {title}
          </h1>
          {intro && (
            <p className="text-zinc-400 font-manrope text-base md:text-lg max-w-2xl leading-relaxed">
              {intro}
            </p>
          )}
        </header>

        <div className="space-y-6">{children}</div>

        {cta && (
          <div className="mt-12 flex flex-col sm:flex-row items-center gap-3">
            {cta.map((c, i) => (
              <a
                key={i}
                href={c.href}
                target={c.external ? '_blank' : undefined}
                rel={c.external ? 'noopener noreferrer' : undefined}
                className={`inline-flex items-center gap-2 px-6 py-3 rounded-full font-manrope font-semibold transition-all ${
                  i === 0
                    ? 'bg-[#D4AF37] text-[#0A0A0A] hover:bg-amber-200'
                    : 'border border-white/20 text-white hover:border-[#D4AF37] hover:text-[#D4AF37]'
                }`}
                data-testid={`portal-cta-${i}`}
              >
                {c.label} <ArrowRight className="w-4 h-4" />
              </a>
            ))}
          </div>
        )}
      </div>
    </PortalLayout>
  );
}

/**
 * "Coming soon" empty state for pages still being built.
 */
export function ComingSoonCard({ note }) {
  return (
    <div className="rounded-2xl bg-[#111111] border border-white/10 p-8 text-center">
      <p className="text-[#D4AF37] font-manrope uppercase tracking-[0.3em] text-[11px] font-bold mb-3">
        Coming soon
      </p>
      <p className="text-zinc-400 font-manrope">
        {note || 'This corner of the portal is being built. Check back soon, brother.'}
      </p>
    </div>
  );
}
